/* eslint-disable react-hooks/exhaustive-deps */
import {
  ActionButton,
  Select
} from "components"
import { Fragment, useEffect, useMemo } from "react"
import {
  Controller,
  FormProvider,
  useForm,
  useFormContext,
} from "react-hook-form"
import moment from "moment"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { convertNumber, useToggle } from "utils"
import { BillServiceType } from "../types/BillServiceTypes"


type Action = "add" | "edit"

type ItemProps = {
    index?: number
    action: Action
    defaultValues?: BillServiceType
    isHideForm?: boolean
    onCancelEditing?: () => void
    onDeleteData?: () => void
    onSubmitData: (value: BillServiceType) => void
    dataProject: FormStateProjectProfile
    dropdownBoq: {
      value:string,
      label:string
    }[]
}

export function TableBillServiceItem(props: ItemProps) {
    const isHideForm = useToggle(props.isHideForm ?? true)
    const defaultValues: BillServiceType = useMemo(
        () => ({
            bill_id:props.defaultValues?.bill_id ?? 0,
            project_transaction_id:props.defaultValues?.project_transaction_id ?? null,
            bill_service_detail_id: props.defaultValues?.bill_service_detail_id ?? 0,
            quantity_order: props.defaultValues?.quantity_order ?? 0,
            quantity_unit: props.defaultValues?.quantity_unit ?? 0,
            product_id: props.defaultValues?.product_id ?? 0,
            project_id: props.defaultValues?.project_id ?? 0,
            price_bill: props.defaultValues?.price_bill ?? 0,
            discount: props.defaultValues?.discount ?? 0,
            total: props.defaultValues?.total ?? 0,
            tax_id: props.defaultValues?.tax_id ?? 0,
            transaction_date:props.defaultValues?.transaction_date ?? '',
            tax_rate: props.defaultValues?.tax_rate ?? 0,
            total_tax_paid: props.defaultValues?.total_tax_paid ?? 0,
            coa_code: props.defaultValues?.coa_code ?? "",
            coa_name: props.defaultValues?.coa_name ?? "",
            description: props.defaultValues?.description ?? "",
            tax_name: props.defaultValues?.tax_name ?? "",
            mr_unit_id: props.defaultValues?.mr_unit_id ?? 0,
            mr_unit_name: props.defaultValues?.mr_unit_name ?? "",
            vendor_id: props.defaultValues?.vendor_id ?? 0,
            vendor_name: props.defaultValues?.vendor_name ?? "",
            trx_code: props.defaultValues?.trx_code ?? "",
            trx_date:props.defaultValues?.trx_date ?? "",
            project_boq_id: props.defaultValues?.project_boq_id ?? 0,
            boq_name: props.defaultValues?.boq_name ?? "",
            trx_source_id: props.defaultValues?.trx_source_id ?? 0,
            trx_source:props.defaultValues?.trx_source ?? 0,
            trx_amount:props.defaultValues?.trx_amount ?? 0
        }),
        [props.defaultValues]
    )

    const methods = useForm<BillServiceType>({
        defaultValues,
        // resolver: yupResolver(validationBoqSchema)
    })

    useEffect(() => methods.reset(defaultValues), [defaultValues])

    const { watch } = methods;
    const total = Number(watch('total')) + Number(watch('total_tax_paid'))
    const description = `${watch('coa_code')} - ${watch('coa_name')} | ${watch('description')}`;
    
  return (
    <FormProvider {...methods}>
      <tr className="">
        {isHideForm.isActive ? (
          <td colSpan={9} />
        ) : (
          <Fragment>
            <td className="text-center">{Number(props.index)+1}</td>
            <td >
              <Controller
                control={methods.control}
                name="trx_code"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="transaction_date"
                render={({ field }) => (
                  <div>{moment(field.value).format('DD/MM/YYYY')}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="vendor_name"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <div>{description}</div>
            </td>

            <td>
              <Controller
                control={methods.control}
                name="quantity_order"
                render={({ field }) => (
                  <div>{field.value}</div>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="mr_unit_name"
                render={({ field }) => (
                  <>{field.value}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="price_bill"
                render={({ field }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="discount"
                render={({ field, fieldState }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="total"
                render={({ field }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              <Controller
                control={methods.control}
                name="total_tax_paid"
                render={({ field, fieldState }) => (
                  <>{convertNumber(Number(field.value)).intoCurrency}</>
                )}
              />
            </td>

            <td>
              {convertNumber(Number(total)).intoCurrency}
            </td>

            <td className="min-w-[100px]">
             <BOQ dropdown={props.dropdownBoq}/>
            </td>

        
            <td className="text-center">
              <section className="flex justify-center items-center">
                {props.action === "edit" && (
                  <ActionButton.Close
                    permission="AT021"
                    onClick={props?.onCancelEditing}
                  />
                )}

                <ActionButton.Add
                  permission="AT021"
                  onClick={() => {
                    methods.handleSubmit((data) =>
                      props.onSubmitData(data)
                    )()
                  }}
                />

                {props.action === "add" && (
                  <ActionButton.Close
                    permission="AT021"
                    onClick={isHideForm.toggle}
                  />
                )}
              </section>
            </td>
          </Fragment>
        )}
      </tr>
    </FormProvider>
  )
}


type BoqDropdownType={
  dropdown:{
    value:string,
    label:string
  }[]
}
function BOQ (props:BoqDropdownType) {
    
    const { control, setValue } = useFormContext<BillServiceType>()
   
    return (
      <Fragment>
        <Controller
          control={control}
          name="project_boq_id"
          render={({ field, fieldState }) => {
            return (
              <section>
                <Select
                  className="w-full"
                  placeholder="Select BOQ"
                  error={fieldState.error?.message}
                  options={props.dropdown}
                  value={
                    field.value
                      ? props.dropdown.find((item) => Number(item.value) === field.value)
                      : null
                  }
                  onChange={(e) => {
                      field.onChange(e?.value)
                      setValue("boq_name", e?.label ?? "")
                  }}
                />
              </section>
            )
          }}
        />
      </Fragment>
    )
  }